import Footer from "../../components/Footer/Footer";
import NavBar from "../../components/NavBar/NavBar";
import CarouselGeneric from "./components/CarouselGeneric/CarouselGeneric";
import CarouselSmall from "./components/SmallCarousel/SmallCarousel";
import { SectionContainer, Subtitle, Title } from "./Styled";
import {images} from "../../constants/HomeCupom/images";
import CategoryCarousel from "./components/CategoryCarousel/CategoryCarousel";
import LojasDestaques from "./components/LojasDestaques/LojasDestaques";
import ComoUtilizarUmCupom from "./components/ComoUsarCupom/ComoUtilizarCupom";
import Login from "../../components/Modal/Login/Login";
import { useState } from "react";
import TopCupons from "./components/TopCoupons/TopCupons";

const contentBanners = [
    ...images,
    // {
    //     loja: "Magalu",
    //     slug: "magazine-luiza",
    //     cashback: "+3% de Cashback",
    //     descricao: "Produtos com até 50% OFF +3% de cashback",
    //     cor: "#0A2342",
    //     imagem: "https://cdn.meucupom.com/store_logos/magazine-luiza.png"
    // },
    // {
    //     loja: "Casas Bahia",
    //     slug: "casas-bahia",
    //     cashback: "+3% de Cashback",
    //     descricao: "Até 40% OFF em diversos produtos",
    //     cor: "#0A2342",
    //     imagem: "https://cdn.meucupom.com/store_logos/casas-bahia.png"
    // }
];

const HomeCupom = () => {
    const [openLoginModal, setOpenLoginModal] = useState(false);
    const handleOpenLoginModal = () => setOpenLoginModal(true);
    const handleCloseLoginModal = () => setOpenLoginModal(false);

    return (
        <>
            <NavBar variant="default"/>
            <SectionContainer>
                <Title variant="h4">
                    Cupons e Cashback para Economizar
                </Title>
                <Subtitle variant="h6">
                    Cupons de desconto e cashback nas melhores lojas para você economizar
                </Subtitle>
            </SectionContainer>
            <CarouselGeneric banners={contentBanners}/>
            {/* Carrossel menor imagens */}
            <CarouselSmall/>
            <CategoryCarousel/>
            <LojasDestaques/>
            <TopCupons/>
            <ComoUtilizarUmCupom onOpenLogin={handleOpenLoginModal} />
            <Footer/>
            <Login open={openLoginModal} handleClose={handleCloseLoginModal}/>
        </>
    )
}
export default HomeCupom;